import React from "react";
import { Badge } from "../core/Badge";

const MAP = {
  open: { tone: "success", icon: "circle-dot" },
  quoted: { tone: "gold", icon: "file-text" },
  hired: { tone: "trust", icon: "handshake" },
  closed: { tone: "neutral", icon: "check" },
  paid: { tone: "success", icon: "check-circle-2" },
  pending: { tone: "warning", icon: "clock" },
  canceled: { tone: "neutral", icon: "x" },
  refunded: { tone: "danger", icon: "rotate-ccw" },
  verified: { tone: "trust", icon: "shield-check" },
  unverified: { tone: "warning", icon: "shield-alert" },
};

export function StatusBadge({ status, label }) {
  const m = MAP[status] || { tone: "neutral" };
  return <Badge tone={m.tone} icon={m.icon}>{label || status}</Badge>;
}
